import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { CalendarDays, Fish } from "lucide-react";

export default function Account() {
  const { user } = useAuth();
  const { t, lang, pick } = useLang();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    api.get("/bookings/mine").then((r) => setBookings(r.data)).catch(() => {});
  }, []);

  if (!user) return null;

  return (
    <div className="container-deg py-20 md:py-28 max-w-4xl" data-testid="account-page">
      <div className="overline">{t("nav.account")}</div>
      <h1 className="font-serif text-4xl mt-3">{user.name}</h1>
      <p className="text-ink-soft text-sm mt-2">{user.email}</p>

      <h2 className="font-serif text-2xl mt-12 mb-4 flex items-center gap-2"><CalendarDays size={18} strokeWidth={1.5} /> {t("nav.myBookings")}</h2>
      {bookings.length === 0 ? (
        <p className="text-ink-soft">No bookings yet.</p>
      ) : (
        <div className="space-y-3">
          {bookings.map((b) => (
            <div key={b.id} className="card-deg p-5 flex items-center justify-between" data-testid={`my-booking-${b.id}`}>
              <div>
                <div className="font-serif text-xl">{lang === "hu" ? b.item_name_hu : b.item_name_en}</div>
                <div className="text-xs text-ink-soft mt-1">{b.start_date} → {b.end_date} · {b.nights} {t("booking.nights")} · {b.guests} {t("booking.guests")}</div>
              </div>
              <div className="text-right">
                <div className="font-serif text-2xl text-accent">€{b.total_amount}</div>
                <div className="text-[11px] uppercase tracking-wider mt-1">
                  <span className={`px-2 py-0.5 ${b.status === "confirmed" ? "bg-primary text-bg-paper" : "bg-bg-muted"}`}>{b.status}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
